export default __webpack_public_path__ + "static/dashboard-screen-d1de91fd204c225ea524f22b3ad1eb59.webp";